import { useQuery } from '@tanstack/react-query';
import { AccountPaymentsQueryKeys } from '@enums/react-query-keys';
import PaymentCardService from '@services/payment-card-service';

const usePaymentCards = (userId: string | undefined) => {
  return useQuery({
    queryKey: [AccountPaymentsQueryKeys.PAYMENT_CARDS, userId],
    queryFn: () => PaymentCardService.getPaymentCards(),
    enabled: !!userId,
  });
};

export default usePaymentCards;
